import { createContext, useContext, useMemo, useState } from "react";

const AppStateContext = createContext();

export function AppStateProvider({ children }) {
  const [addressId, setAddressId] = useState(null);
  const [address, setAddress] = useState(null);
  const [selection, setSelection] = useState(null);

  const value = useMemo(() => ({
    addressId, setAddressId,
    address, setAddress,
    selection, setSelection
  }), [addressId, address, selection]);

  return <AppStateContext.Provider value={value}>{children}</AppStateContext.Provider>;
}

export function useAppState() { return useContext(AppStateContext); }
